import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VpnKeyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vpn_key"}/>
}
